import { c as _c } from "react/compiler-runtime";
import { Price } from '@7f-ui/components/price';
type ExperienceCardPriceProps = {
  price: number;
  currency?: string;
  priceCategory?: string | null;
  hasMultiplePrices?: boolean;
};
export function ExperienceCardPrice(t0) {
  const $ = _c(11);
  const {
    price,
    currency,
    priceCategory,
    hasMultiplePrices
  } = t0;
  const t1 = hasMultiplePrices ? "ab " : null;
  let t2;
  if ($[0] !== currency || $[1] !== price) {
    t2 = <Price amount={price} currency={currency} />;
    $[0] = currency;
    $[1] = price;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <span className="font-semibold">{t1}{t2}</span>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== priceCategory) {
    t4 = priceCategory && <span>{` pro ${priceCategory} inkl. MwSt.`}</span>;
    $[6] = priceCategory;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <p className="flex-1 @xl:font-body-small font-body-copy">{t3}{t4}</p>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}